export default __webpack_public_path__ + "static/goodghosting-9396603d3662b6f011cdf0861683c297.jpg";